var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfoSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon info selected",
    viewBox: "0 0 42.002 42.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.002 42a21.006 21.006 0 0 1-8.174-40.352 21 21 0 0 1 23.021 34.2A20.937 20.937 0 0 1 21.002 42zm0-37A16 16 0 0 0 9.688 32.312 16 16 0 1 0 32.317 9.688 15.9 15.9 0 0 0 21.002 5zm0 31a15 15 0 1 1 10.607-4.394A14.9 14.9 0 0 1 21.002 36zm-1.84-17.584-1.16 11.026h3.184l1.164-11.024zM21.302 13a2.127 2.127 0 0 0-2.187 2.163 1.743 1.743 0 0 0 1.848 1.752 2.148 2.148 0 0 0 2.184-2.159A1.742 1.742 0 0 0 21.302 13z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfoSelected);
export default __webpack_public_path__ + "static/media/icon-info-selected.091e45e1145d5a59b79f481bce6df652.svg";
export { ForwardRef as ReactComponent };